var _react_refresh_temp_1;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { C } from '#integrations';
import { AlertOctagonIcon, AlertTriangleIcon, CheckCircleBrokenIcon, InfoCircleIcon, } from '../icons';
import { MessageBoxTestIdFactory } from './interactions';
import styles from './MessageBox.module.css';
const ALIGN_CLASS_MAP = {
    center: styles.AlignCenter,
    start: styles.AlignStart,
};
const boxTypeIconMapper = {
    alert: AlertTriangleIcon,
    negative: AlertOctagonIcon,
    informative: InfoCircleIcon,
    positive: CheckCircleBrokenIcon,
};
const TYPE_CLASS_MAP = {
    alert: styles.Alert,
    negative: styles.Error,
    informative: styles.Info,
    positive: styles.Success,
};
export const MessageBox = ({ align = 'center', children, className, 'data-testid': testid, id, overrideIcon, type, }) => {
    const alignClass = ALIGN_CLASS_MAP[align];
    const Icon = overrideIcon || boxTypeIconMapper[type];
    const styleTypeClass = TYPE_CLASS_MAP[type];
    return (_jsxs("div", { className: C(styles.Container, className, alignClass, styleTypeClass), "data-testid": MessageBoxTestIdFactory.getMessageBoxTestId(testid), id: id, children: [_jsx("div", { className: styles.Icon, children: _jsx(Icon, { size: "middle" }) }), _jsx("p", { className: styles.Content, children: children })] }));
};
_react_refresh_temp_1 = MessageBox;
$RefreshReg$(_react_refresh_temp_1, "MessageBox");
